/**
 * The shell may be placed inside a constrained host, so this deliberately uses
 * the shell's measured width rather than trying to infer a device type.
 */
export const PINNED_NAVIGATION_MIN_WIDTH = 1024;

export function shouldPinNavigation(shellWidth: number, pinnedPreference: boolean): boolean {
  return pinnedPreference && shellWidth >= PINNED_NAVIGATION_MIN_WIDTH;
}
